export default "__VITE_ASSET__BKt_TK4B__"